import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createTutorialVideoSaga } from "src/store/tutorials/saga";
import * as Yup from "yup";

const TutorialVideoCreateForm = ({
  playlistId,
  onHide,
  open,
  onSuccessClick,
}: {
  playlistId: string;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("Tutorials.CreateVideo").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        TutorialPlaylistId: playlistId,
        Title: "",
        Description: "",
        Order: 0,
        DurationSec: 0,
        IsActive: true,
        VideoFile: undefined,
        PosterFile: undefined,
        Translates: languages.map((x) => ({
          LanguageId: x.EnumId,
          Title: "",
          Description: "",
        })),
      }}
      onSubmit={(values) => {
        dispatch(
          createTutorialVideoSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            body: values,
          })
        );
      }}
      validationSchema={Yup.object().shape({})}
      multilanguageinputs={[
        { field: "Title", label: t("Tutorials.Title").toString() },
        { field: "Description", label: t("Tutorials.Description").toString() },
      ]}
      inputs={[
        { field: "Order", label: t("Tutorials.Order").toString(), type: "number" },
        {
          field: "DurationSec",
          label: t("Tutorials.DurationSec").toString(),
          type: "number",
        },
        { field: "IsActive", label: t("Tutorials.IsActive").toString(), type: "switch" },
        {
          field: "VideoFile",
          label: t("Tutorials.VideoFile").toString(),
          type: "file",
          accept: "video/*",
        },
        {
          field: "PosterFile",
          label: t("Tutorials.PosterFile").toString(),
          type: "file",
          accept: "image/*",
        },
      ]}
    />
  );
};
export default TutorialVideoCreateForm;
